/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Writing_StyleInputs */

const en_writing_style = /** @type {(inputs: Writing_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Writing Style`)
};

const es_writing_style = /** @type {(inputs: Writing_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de Escritura`)
};

const fr_writing_style = /** @type {(inputs: Writing_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style d'Écriture`)
};

const de_writing_style = /** @type {(inputs: Writing_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schreibstil`)
};

const ja_writing_style = /** @type {(inputs: Writing_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライティングスタイル`)
};

const zh_writing_style = /** @type {(inputs: Writing_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写作风格`)
};

const ar_writing_style = /** @type {(inputs: Writing_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أسلوب الكتابة`)
};

const id_writing_style = /** @type {(inputs: Writing_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaya Penulisan`)
};

const it_writing_style = /** @type {(inputs: Writing_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stile di Scrittura`)
};

const ru_writing_style = /** @type {(inputs: Writing_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стиль Написания`)
};

const pt_writing_style = /** @type {(inputs: Writing_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo de Escrita`)
};

const ko_writing_style = /** @type {(inputs: Writing_StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문체`)
};

/**
* | output |
* | --- |
* | "Writing Style" |
*
* @param {Writing_StyleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const writing_style = /** @type {((inputs?: Writing_StyleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Writing_StyleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_writing_style(inputs)
	if (locale === "es") return es_writing_style(inputs)
	if (locale === "fr") return fr_writing_style(inputs)
	if (locale === "de") return de_writing_style(inputs)
	if (locale === "ja") return ja_writing_style(inputs)
	if (locale === "zh") return zh_writing_style(inputs)
	if (locale === "ar") return ar_writing_style(inputs)
	if (locale === "id") return id_writing_style(inputs)
	if (locale === "it") return it_writing_style(inputs)
	if (locale === "ru") return ru_writing_style(inputs)
	if (locale === "pt") return pt_writing_style(inputs)
	return ko_writing_style(inputs)
});